import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { TopBar } from '@/components/layout/TopBar'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { FEATURE_FLAGS } from '@/constants/featureFlags'
import { CreateAgentProvider } from '@/contexts/CreateAgentContext'
import { DashboardSearchProvider } from '@/contexts/DashboardSearchContext'
import { useAppcuesPageTracking } from '@/hooks/useAppcuesPageTracking'
import { useOrganizationFeatureFlag } from '@/hooks/useOrganizationFeatureFlag'
import { useContainedScroll, useFullBleed } from '@/hooks/useRouteHandles'
import { cn } from '@/lib/utils'
import { intercomService } from '@/services/intercom'

export function AppLayout() {
  const fullBleed = useFullBleed()
  const containedScroll = useContainedScroll()
  const { enabled: intercomEnabled } = useOrganizationFeatureFlag(
    FEATURE_FLAGS.INTERCOM
  )

  useAppcuesPageTracking()

  useEffect(() => {
    if (intercomEnabled) {
      intercomService.init()
      return () => intercomService.destroy()
    }
  }, [intercomEnabled])

  if (fullBleed) {
    return (
      <div className="flex h-screen flex-col bg-background">
        <main className="flex-1 overflow-y-auto bg-secondary">
          <Outlet />
        </main>
      </div>
    )
  }

  return (
    <CreateAgentProvider>
      <DashboardSearchProvider>
        <SidebarProvider>
          <AppSidebar />
          {/* containedScroll pins the inset to the viewport height so the page's
              own panes scroll instead of the whole column growing past the
              viewport; default keeps the min-height, grow-and-scroll behavior. */}
          <SidebarInset
            className={containedScroll ? 'h-svh overflow-hidden' : undefined}
          >
            <TopBar />
            <main
              className={cn(
                'min-w-0 flex-1 bg-secondary',
                containedScroll ? 'overflow-hidden' : 'overflow-y-auto'
              )}
            >
              <Outlet />
            </main>
          </SidebarInset>
        </SidebarProvider>
      </DashboardSearchProvider>
    </CreateAgentProvider>
  )
}
